<div *ngIf="loadingData" class="alert alert-info"><strong><i class="la la-spinner la-spin"></i> Nalagam
  podatke</strong></div>
<ng-container *ngIf="!loadingData && (timetable || createNew)">
  <form [formGroup]="form" novalidate (submit)="update(form)">
    <div class="form-group">
      <label for="title">Interno ime urnika</label>
      <input type="text" class="form-control" id="title" formControlName="title">
      <small class="form-text text-danger" *ngIf="form.controls.title.touched && form.controls.title.invalid">
        Interno ime urnika je obvezno
      </small>
    </div>

    <div class="form-row">
      <div class="form-group col-md-6">
        <label for="email">Privzeti e-naslov</label>
        <input type="text" class="form-control" id="email" formControlName="email">
        <small class="form-text text-danger" *ngIf="form.controls.email.touched && form.controls.email.invalid">
          Elektronski naslov ni pravilen.
        </small>
      </div>

      <div class="form-group col-md-6">
        <label for="phoneNumber">Privzeti telefon</label>
        <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber">
      </div>
    </div>

    <div class="form-group">
      <label for="comments">Opombe</label>
      <textarea class="form-control" id="comments" formControlName="comments" rows="4"></textarea>
    </div>

    <table class="table table-sm mt-5">
      <thead>
      <tr>
        <th class="uppercase">Dan</th>
        <th class="uppercase" width="50%">Od / Do</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let day of ['Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota', 'Nedelja']; let d = index;">
        <td>
          <div class="my-2">{{day}}</div>
        </td>
        <td>
          <div [formArrayName]="'day'+d" *ngFor="let item of form.get('day'+d).controls; let i = index;">
            <div class="input-group my-1" [formGroupName]="i">
              <input type="text" class="form-control form-control-sm" formControlName="start">
              <input type="text" class="form-control form-control-sm" formControlName="end">
              <div class="input-group-append">
                <button class="btn btn-sm btn-outline-info" type="button" *ngIf="i === 0" (click)="addHours(d)">
                  <i class="la la-plus"></i>
                </button>
                <button class="btn btn-sm btn-outline-danger" type="button" *ngIf="i > 0" (click)="removeHours(d, i)">
                  <i class="la la-remove"></i>
                </button>
              </div>
            </div>
            <small id="passwordHelpBlock" class="form-text text-danger" *ngIf="item.touched && item.invalid">
              Ura mora biti zapisana v obliki <strong>12:00</strong>.
            </small>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <hr>
    <div class="d-flex justify-content-between">
      <div>
        <div class="style-msg successmsg" *ngIf="formSucces">
          <div class="sb-msg">
            <i class="icon-thumbs-up"></i>
            <strong>Bravo!</strong>
            {{formSucces}}
          </div>
        </div>
        <div class="style-msg errormsg" *ngIf="formError">
          <div class="sb-msg">
            <i class="icon-thumbs-up"></i>
            <strong>Napaka!</strong>
            {{formError}}
          </div>
        </div>
      </div>
      <button type="submit" class="button button-3d button-primary button-disabled" [disabled]="formProcessing">
        <i class="la la-check" *ngIf="!formProcessing"></i>
        <i class="la la-spinner la-spin" *ngIf="formProcessing"></i>
        <ng-container *ngIf="createNew">Kreiraj urnik</ng-container>
        <ng-container *ngIf="!createNew">Shrani spremembe</ng-container>
      </button>
    </div>
  </form>
</ng-container>
